<section class="section white-100" *ngIf="_featureData">
  <div [ngClass]="isInside ? 'section-container-inside' : 'section-container'">
    <h2 class="section-heading mar-b-48">
      {{ _featureData?.title }}
    </h2>
    <div class="section-turbocharge-grid">
      <!------- Built for creators ------->
      <ng-container *ngFor="let data of _featureData.blocks; let i = index">
        <div class="section-turbocharge" [ngClass]="isRevert(i)">
          <div class="your-business-content">
            <div class="revolutionize-team-heading">
              {{ data.title }}
            </div>
            <div
              class="your-business-description mar-t-16 mar-b-24"
              [innerHtml]="data.content | toHtml"
            ></div>
            <ng-container 
              *ngIf="data?.buttons">
              <a href="{{ button?.fields?.redirectLink | urlParams: queryParams }}" class="link-xl" *ngFor="let button of data?.buttons">
                {{ button?.fields?.buttonText
                }}<span class="arrow">&rarr;</span>
              </a>
            </ng-container>
          </div>
          <div class="financial-stack" [ngClass]="getBgClass(i)">
            <figure *ngIf="data?.image">
              <img
                alt="{{ data.image[0]?.fields?.title }}"
                src="{{ data.image[0]?.fields?.file?.url }}"
              />
            </figure>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
